import React from 'react';
import Button from '../../ui/Button';
import { Trash, Loader } from 'lucide-react';

/**
 * Modal para confirmar exclusão de um item
 * 
 * @param {Object} props - Propriedades do componente
 * @param {boolean} props.isOpen - Controla se o modal está aberto
 * @param {Function} props.onClose - Função chamada ao fechar o modal
 * @param {Function} props.onConfirm - Função chamada ao confirmar a exclusão
 * @param {string} props.itemName - Nome do item a ser excluído
 * @param {string} props.itemType - Tipo do item (serviço ou categoria)
 * @param {boolean} props.isSaving - Indica se há uma operação de salvamento em andamento
 */
const ConfirmDeleteModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  itemName, 
  itemType,
  isSaving = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full animate-fade-in">
        <div className="p-6">
          <div className="flex items-center mb-4">
            <Trash className="h-5 w-5 text-red-500 mr-2" />
            <h3 className="text-lg font-medium text-gray-900">Confirmar exclusão</h3>
          </div>
          
          <p className="text-gray-600 mb-4">
            {itemType === 'service' 
              ? `Tem certeza que deseja excluir o serviço "${itemName || ''}"?` 
              : `Tem certeza que deseja excluir a categoria "${itemName || ''}" e todos os serviços vinculados a ela?`
            }
          </p>
          
          <div className="flex justify-end space-x-3">
            <Button
              variant="outline"
              onClick={onClose}
              disabled={isSaving}
            >
              Cancelar
            </Button>
            <Button 
              variant="danger"
              onClick={onConfirm}
              disabled={isSaving}
              className="flex items-center"
            >
              {isSaving ? (
                <>
                  <Loader className="w-4 h-4 mr-2 animate-spin" />
                  Excluindo...
                </>
              ) : (
                'Excluir'
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal; 